import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

const rootRouteRef = createRouteRef({
  id: "cortex"
});
const scorecardsRouteRef = createSubRouteRef({
  id: "scorecards",
  parent: rootRouteRef,
  path: "/scorecards"
});
const scorecardRouteRef = createSubRouteRef({
  id: "scorecard",
  path: "/scorecards/:id",
  parent: rootRouteRef
});
const scorecardServiceDetailsRouteRef = createSubRouteRef({
  id: "scorecardServiceDetails",
  path: "/scorecards/:scorecardId/:namespace/:kind/:name",
  parent: rootRouteRef
});
const initiativeRouteRef = createSubRouteRef({
  id: "initiative",
  path: "/initiatives/:id",
  parent: rootRouteRef
});

export { initiativeRouteRef, rootRouteRef, scorecardRouteRef, scorecardServiceDetailsRouteRef, scorecardsRouteRef };
//# sourceMappingURL=routes.esm.js.map
